import { render, staticRenderFns } from "./NotificationsToRead.vue?vue&type=template&id=6a73d3d6&"
import script from "./NotificationsToRead.vue?vue&type=script&lang=js&"
export * from "./NotificationsToRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports